import React, {Dispatch, SetStateAction} from 'react';
import {Autocomplete, TextField, Box} from '@mui/material';
import {useSnackbar} from 'notistack';

import {getIsBhOptions} from '@shared/services/service-handlers/PrivateService';

import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';

interface IsBHFilterProps {
  module: string;
  optionValue: string;
  setOptionValue: Dispatch<SetStateAction<string>>;
  setIsBHSelected?: Dispatch<SetStateAction<boolean | string>>;
  disabled?: boolean;
  autoCompleteProps?: any;
}

const IsBhFilter = (props: IsBHFilterProps): React.ReactElement => {
  const {module = ''} = props;
  const {enqueueSnackbar} = useSnackbar();
  const [currentValue, setCurrentValue]: any = React.useState('');
  const [options, setOptions]: any = React.useState([]);
  const [otherValue, setOtherValue] = React.useState<string | null | undefined>(
    null
  );

  const init = async () => {
    try {
      setOptions([]);
      const results = await getIsBhOptions(module);

      setOptions(results?.data);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box display="flex" flexDirection="column">
      <Autocomplete
        {...props?.autoCompleteProps}
        disabled={props?.disabled}
        options={options}
        value={currentValue}
        ListboxProps={{ style: { maxHeight: 150 } }}
        onInputChange={(event, newInputValue) => {
          setCurrentValue(newInputValue);
        }}
        onChange={(event, newValue: string) => {
          setCurrentValue(newValue);
          props?.setOptionValue(newValue);
          if (newValue?.toLowerCase() === 'other') {
            setOtherValue('');
            props?.setOptionValue('')
          }
          // makeAuditLog(newValue, cancelToken);
        }}
        renderInput={params => <TextField {...params} label="Select Reason" />}
      />
      {currentValue === 'Other' ? (
        <TextField
          sx={{mt: 1}}
          value={otherValue ?? ''}
          onChange={event => {
            setOtherValue(event?.target?.value);
            props?.setOptionValue(event?.target?.value);
          }}
          label="Enter Reason"
        />
      ) : null}
    </Box>
  );
};

export default IsBhFilter;
